import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  SupervisorService,
  FiltersService
} from '../../../shared';

@Component({
  selector: 'app-supervisor-new',
  templateUrl: './supervisor-new.component.html',
  styleUrls: ['./supervisor-new.component.scss']
})
export class SupervisorNewComponent implements OnInit {
  title = "NOVO SUPERVISOR";
  subtitle = "Utilize os campos abaixo para cadastrar um novo supervisor";
  urlBack = "/panel/supervisor/list";

  providersArr;

  phone;

  newSupervisor = new FormGroup({
    cdFornecedor: new FormControl(''),
    cdsLogin: new FormControl(''),
    nmOperador: new FormControl(''),
    nrTelefone: new FormControl(''),
    dsEmail: new FormControl(''),
    dsSenha: new FormControl('')
  });

  constructor(
    private headerService: HeaderService,
    private supervisorService: SupervisorService,
    private loadingBarService: LoadingBarService,
    private filtersService: FiltersService
  ) { }

  ngOnInit() {
    this.headerService.changeTitle('Cadastro de novo supervisor');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.filtersService.listProviders().subscribe((response) => {
      this.providersArr = response['data'];
    });
  }

  maskPhone(number) {
    if (number.length < 13) {
      this.phone = "(00) 0000-0000";
    } else if (number.length === 14) {
      this.phone = "(00) 0000-00009";
    } else {
      this.phone = "(00) 00000-0000";
    }
  }

  resetValues() {
    this.newSupervisor.patchValue({
      cdFornecedor: "",
      cdsLogin: "",
      nmOperador: "",
      nrTelefone: "",
      dsEmail: "",
      dsSenha: ""
    });
  }

  addNewServiceProvider() {
    this.loadingBarService.start();

    this.supervisorService.addSupervisor(this.newSupervisor.value).subscribe((response) => {
      this.loadingBarService.complete();

      this.newSupervisor.reset();

      this.resetValues();

      Swal({
        type: "success",
        title: "Supervisor cadastrado",
        text: "O supervisor será exibido na listagem",
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      });
    });
  }

}
